import { render, staticRenderFns } from "./InvoiceTypeSetupList.vue?vue&type=template&id=fed1021c&scoped=true&"
import script from "./InvoiceTypeSetupList.vue?vue&type=script&lang=js&"
export * from "./InvoiceTypeSetupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed1021c",
  null
  
)

export default component.exports